export default __webpack_public_path__ + "185d0d0c8a7992c6cd5b70df14a43311.ico";